import {
  Portal,
  TooltipArrow,
  TooltipArrowTip,
  TooltipContent,
  TooltipPositioner,
  TooltipRoot,
  type TooltipRootProps,
  TooltipTrigger,
} from "@ark-ui/react";
import { type ReactNode } from "react";
import { type Merge } from "type-fest";

import { css, sva } from "../../styled-system/css";

/** @deprecated 代わりに`TOOLTIP_CONTENT_STYLE`を使用する。 */
export const tooltipStyles = sva({
  slots: ["arrow", "arrowTip", "content"],
  base: {
    arrow: { "--arrow-size": "8px", "--arrow-background": "colors.background" },
    arrowTip: {
      borderColor: "border",
      borderStyle: "solid",
      borderTopWidth: "1px",
      borderLeftWidth: "1px",
      backgroundColor: "var(--arrow-background)",
    },
    content: {
      backgroundColor: "background",
      boxShadow: "md",
      borderColor: "border",
      borderRadius: "8px",
      borderStyle: "solid",
      borderWidth: "1px",
      fontSize: "14px",
      paddingX: "16px",
      paddingY: "12px",

      "&[data-state='open']": { animation: "fade-in 0.2s ease-out" },
      "&[data-state='closed']": { animation: "fade-out 0.2s ease-in" },
    },
  },
});

export const TOOLTIP_CONTENT_STYLE = css.raw({
  backgroundColor: "white",
  boxShadow: "md",
  borderColor: "#E4E4E7",
  borderRadius: "8px",
  borderStyle: "solid",
  borderWidth: "1px",
  fontSize: "14px",
  paddingX: "16px",
  paddingY: "12px",

  "&[data-state='open']": { animation: "fade-in 0.2s ease-out" },
  "&[data-state='closed']": { animation: "fade-out 0.2s ease-in" },

  '& div[data-scope="tooltip"][data-part="arrow"]': {
    "--arrow-size": "8px",
    "--arrow-background": "colors.background",
  },

  '& div[data-scope="tooltip"][data-part="arrow-tip"]': {
    borderColor: "#E4E4E7",
    borderStyle: "solid",
    borderTopWidth: "1px",
    borderLeftWidth: "1px",
    backgroundColor: "white",
  },
});

export function Tooltip({
  content,
  positioning,
  trigger,
  ...properties
}: Merge<TooltipRootProps, { children?: never; content: ReactNode; trigger: ReactNode }>) {
  return (
    <TooltipRoot
      closeDelay={100}
      openDelay={100}
      positioning={{ placement: "top", ...positioning }}
      {...properties}
    >
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <Portal>
        <TooltipPositioner>
          <TooltipContent className={css(TOOLTIP_CONTENT_STYLE)}>
            <TooltipArrow>
              <TooltipArrowTip />
            </TooltipArrow>
            {content}
          </TooltipContent>
        </TooltipPositioner>
      </Portal>
    </TooltipRoot>
  );
}
